import Axios from 'axios'
import qs from 'qs'

const SERVLET_REFERENCE_VALUES = {
	first_name: 'first_name',
	last_name: 'last_name',
	lead_source: 'source',
	email: 'email',
	oid: 'oid',
	retURL: 'retURL',
	celular: 'mobile',
	telefone: 'mobile',
	campanha: '00N1a000009fxkB',
	canal_vendas: '00N1a000009fxZr',
	curso_id: '00N1a000009fxa8',
	curso_nome: '00N1a000009fxa0',
	curso_tipo: '00N1a000009fxaO',
	concurso: '00N1a000009fxZz',
	tipo_ingresso: '00N1P00000AWlAb',
	estado: '00N1a000009fxa5',
	uf: '00N1a000009fxa5',
	cidade: '00N1a000009fxZt',
	contato_whatsapp: '00N1P00000AWwUw',
	cpf: '00N1a000009fwqc',
	facebook_id: 'facebook_id',
	google_id: 'google_id',
	has_celular: 'has_celular'
}

const SALES_FORCE_REFERENCE_VALUES = {
	curso_tipo: 'v0',
	nome: 'v1',
	email: 'v2',
	celular: 'v3',
	uf: 'v4',
	estado: 'v4',
	cidade: 'v5',
	curso_polo: 'v6',
	curso_id: 'v7',
	origem: 'v8',
	tipo_ingresso: 'v11',
	contato_whatsapp: 'v12',
}

const CLICK_TO_CALL_REFERENCE_VALUES = {
	telefone: 'n',
	mensagem: 'p',
	cpf: 'cpf',
	nome: 'nome'
}

class LeadFael {
	constructor(options = {endpoint: ''}) {
		const sales_force_servlet = document.querySelector('meta[name="sales_force_servlet"]')
		const sales_force_oid = document.querySelector('meta[name="sales_force_oid"]')

		this.sales_force_servlet = sales_force_servlet ? sales_force_servlet.getAttribute('content') : ''
		this.sales_force_oid = sales_force_oid ? sales_force_oid.getAttribute('content') : ''
		this.endpoint = `${options.endpoint}/`

		this.setAxiosInterceptors()
	}

	get sales_force_url() {
		return this.getSalesForceUrl('sales_force_url')
	}

	getSalesForceUrl(metaName = 'sales_force_url') {
		metaName = metaName || 'sales_force_url'
		const sales_force_url = document.querySelector(`meta[name="${metaName}"]`)
		return sales_force_url ? sales_force_url.getAttribute('content') : ''
	}

	setAxiosInterceptors() {
		Axios.interceptors.response.use((response) => response, (error) => {
			if (typeof error.response === 'undefined') {
				console.warn(`Ocorreu um erro de rede. Possivelmente relacionado a CORS (Cross-Origin Resource Sharing) ou falha de conexão.`);
				return Promise.resolve({cors: true})
			}
			return Promise.reject(error)
		})
	}

	// eslint-disable-next-line
	async send(route = 'save-lead', apiData = {}, servletData = null, redirectParams = null, salesForceMetaName) {
		let sales_id = await this.sendApi(route, apiData)
		// await this.sendServlet(servletData ? servletData : apiData)
		await this.redirectSalesForce(redirectParams ? redirectParams : apiData, sales_id.data.salesforce_id, this.getSalesForceUrl(salesForceMetaName))
	}

	async sendFaleComAFael(route = 'custom/save-lead', data = {}) {
		await this.sendClickToCall(data)
		await this.sendApi(route, Object.assign({}, {origem: 'fale-com-a-fael'}, data))
	}

	async sendTo(route, data = {}) {
		return await Axios
		.post(route, data)
		.then(response => {
			if (response.cors)
				return Promise.reject(response)
			return response
		})
		.catch(error => {
			if (error.cors)
				return Promise.reject({
					msg: 'NETWORK_ERROR',
					status: 499
				})
			return Promise.reject(error.response.data)
		})
	}

	async sendApi(route, formulario) {
		return await this
		.sendTo(this.endpoint + route, formulario)
		.then(response => response)
		.catch(error => Promise.reject(error))
	}

	async sendServlet(formulario) {
		let form = {oid: this.sales_force_oid}

		Object.keys(formulario).forEach(key => {
			if (key == 'nome') {
				let splited_name = formulario['nome'].split(' ')
				form['first_name'] = splited_name.shift()
				form['last_name'] = ''
				for (let i in splited_name)
					form['last_name'] += splited_name[i] + ' '
				form['last_name'] = form['last_name'].trim()
			} else if (SERVLET_REFERENCE_VALUES[key]) {
				form[SERVLET_REFERENCE_VALUES[key]] = formulario[key]
			}
		})

		return await this
		//.sendTo(this.sales_force_servlet, form)s
		.sendTo(this.endpoint + 'send-salesforce', form)
		.then(response => response)
		.catch(error => console.warn(error.msg, '- sendServlet'))
	}

	async redirectSalesForce(formulario, sales_id = false, sales_force_url) {
		if (sales_id) {
			setTimeout(() => {
				let params = {
					id: sales_id
				}
				if (formulario['curso_tipo'].toUpperCase() == "POS") {
					params.v0 = "POS"
					params.v10 = "FAEL035"
				}
				window.location.href = sales_force_url + '?' + qs.stringify(params)
			}, 1000)
			return
		}

		// Parametros Obrigatórios
		let params = {
			v0: '',
			v1: '',
			v2: '',
			v3: '',
			v4: '',
			v5: '',
			v6: '',
			v7: '',
			v8: '',
			v12: ''
		}

		Object.keys(formulario).forEach(key => {
			if (key == 'curso_tipo') {
				if (window.location.pathname == '/')
					delete params[SALES_FORCE_REFERENCE_VALUES['curso_tipo']]
				else
					params[SALES_FORCE_REFERENCE_VALUES['curso_tipo']] = formulario['curso_tipo'].toUpperCase()
			} else if (key == 'celular') {
				params[SALES_FORCE_REFERENCE_VALUES['celular']] = formulario['celular'].replace(/\D/gi, '')
			} else if (SALES_FORCE_REFERENCE_VALUES[key]) {
				params[SALES_FORCE_REFERENCE_VALUES[key]] = formulario[key]
			}
		})

		if (formulario['curso_tipo'].toUpperCase() == "POS")
			params.v10 = "FAEL035"
		if (localStorage.getItem('v6') !== null) {
			params.v6 = localStorage.getItem('v6');
		}
		if (localStorage.getItem('v10') !== null) {
			params.v10 = localStorage.getItem('v10');
		}
		setTimeout(() => {
			window.location.href = sales_force_url + '?' + qs.stringify(params)
		}, 1000)
	}

	async sendClickToCall(formulario) {
		let form = {}
		Object.keys(formulario).forEach(key => {
			if (key == 'cpf' || key == 'telefone')
				form[CLICK_TO_CALL_REFERENCE_VALUES[key]] = formulario[key].replace(/\D/gi, '')
			else
				form[CLICK_TO_CALL_REFERENCE_VALUES[key]] = formulario[key]
		})

		return await this
		.sendTo(this.endpoint + `dial-save`, {
			url: `https://dial.fael.edu.br/dial/clicktocall.php?${qs.stringify(form)}`
		})
	}

	install(Vue, options = {endpoint: ''}) {
		Vue.prototype.$leads = new LeadFael(options)
	}
}

export default new LeadFael();